import { Page } from "containers/Page";
import { Container } from "./style";
import { useForm } from "react-hook-form";
import { Form, Row, Col } from "react-bootstrap";
import { IExtracaoAtpvs } from "./interfaces/IExtracaoAtpvs";
import { useExtracaoAtpv } from "./hooks/useExtracaoAtpv";
import { useRef, useState } from "react";
import { PrimaryButton } from "components/Button/style";

export function ExtracaoAtpv() {
  const { handleSubmit } = useForm<IExtracaoAtpvs>();
  const { loading, extrairAtpvs } = useExtracaoAtpv();
  const [tipoArquivo, setTipoArquivo] = useState<"PDF" | "ZIP" | null>(null);
  const [arquivos, setArquivos] = useState<File[]>([]);
  const pdfInputRef = useRef<HTMLInputElement>(null);
  const zipInputRef = useRef<HTMLInputElement>(null);

  function handleFileChangePdf(event: React.ChangeEvent<HTMLInputElement>) {
    const selectedFiles = event.target.files;
    if (!selectedFiles) return;

    const pdfs = Array.from(selectedFiles).filter((file) =>
      file.name.toLowerCase().endsWith(".pdf")
    );

    if (pdfs.length !== selectedFiles.length) {
      alert("Alguns arquivos foram ignorados por não serem PDF.");
    }

    setTipoArquivo("PDF");
    setArquivos(pdfs);
  }

  function handleFileChangeZip(event: React.ChangeEvent<HTMLInputElement>) {
    const selectedFiles = event.target.files;
    if (!selectedFiles) return;

    const zip = Array.from(selectedFiles).filter((file) =>
      file.name.toLowerCase().endsWith(".zip")
    );

    if (zip.length !== selectedFiles.length) {
      alert("Alguns arquivos foram ignorados por não serem ZIP.");
    }

    setTipoArquivo("ZIP");
    setArquivos(zip);
  }

  async function onSubmit() {
    if (!arquivos.length) {
      alert("Selecione pelo menos um arquivo.");
      return;
    }
    await extrairAtpvs({ arquivos });
    setArquivos([]);
    setTipoArquivo(null);

    if (pdfInputRef.current) {
      pdfInputRef.current.value = "";
    }
    if (zipInputRef.current) {
      zipInputRef.current.value = "";
    }
  }

  return (
    <Page lastPage="Home / Backoffice" title="Extração ATPV">
      <Container>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formFile">
                <Form.Label>Importar arquivos PDF</Form.Label>
                <Form.Control
                  type="file"
                  accept=".pdf"
                  multiple
                  onChange={handleFileChangePdf}
                  disabled={loading}
                  ref={pdfInputRef}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <PrimaryButton
                type="submit"
                disabled={loading || !arquivos.length || tipoArquivo === "ZIP"}
              >
                {loading && tipoArquivo === "PDF"
                  ? "Processando..."
                  : "Extrair ATPVs"}
              </PrimaryButton>
            </Col>
          </Row>
        </Form>
        <hr></hr>
        <Form onSubmit={handleSubmit(onSubmit)} style={{ marginTop: "24px" }}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group controlId="formFile">
                <Form.Label>Importar arquivo ZIP</Form.Label>
                <Form.Control
                  type="file"
                  accept=".zip"
                  onChange={handleFileChangeZip}
                  disabled={loading}
                  ref={zipInputRef}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <PrimaryButton
                type="submit"
                disabled={loading || !arquivos.length || tipoArquivo === "PDF"}
              >
                {loading && tipoArquivo === "ZIP"
                  ? "Processando..."
                  : "Extrair ATPVs"}
              </PrimaryButton>
            </Col>
          </Row>
        </Form>
      </Container>
    </Page>
  );
}
